import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Person } from '../../../models/person';
import { PersonService } from '../../../providers/person.service';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { faSpinner }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-list-user-people',
  templateUrl: './list-user-people.component.html',
styleUrls:  ['./list-user-people.component.css']
})
export class ListUserPeopleComponent extends SmsAbstractAppPage implements OnInit {

  faSpinner = faSpinner;
  search_in_progress: boolean;

  @Output() person_selected$: EventEmitter<Person> = new EventEmitter<Person>();
  people_list: Person[] = [];

  constructor(private personService: PersonService) {
  	super();
  }

  ngOnInit() {
  	this.personService.getList().then(people => {
  		this.people_list = people;
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleSelectPerson(person: Person){
  	this.person_selected$.emit(person);
  }

}
